import React from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'

const RenderSubRoutes = ({ routes, state }: any) => {
	const location = useLocation()
	
	// Extract the relative path from linkPattern
	// Since we're inside a route like /locations/:id/*, nested routes are relative to that
	// linkPattern might be "/locations/:id/projects" -> we want "projects"
	const getRelativePath = (linkPattern: string) => {
		if (!linkPattern) return '*'
		
		// Get the base path (everything up to and including the last param or known segment)
		// For /locations/:id/projects, we want to extract "projects"
		const patternParts = linkPattern.split('/').filter(Boolean)
		const currentParts = location.pathname.split('/').filter(Boolean)
		
		// Find the common prefix length (matching segments and params)
		let commonLength = 0
		for (let i = 0; i < Math.min(patternParts.length, currentParts.length); i++) {
			const patternPart = patternParts[i]
			// If it's a param (starts with :) or matches exactly, continue
			if (patternPart?.startsWith(':') || patternPart === currentParts[i]) {
				commonLength = i + 1
			} else {
				break
			}
		}
		
		// Return the remaining parts as relative path
		const relativeParts = patternParts.slice(commonLength)
		if (relativeParts.length === 0) {
			return '*' // Catch-all for exact match
		}
		
		return relativeParts.join('/')
	}

	return (
		<Routes>
			{routes.map((link: any, index: number) => {
				if (link.redirectFrom && link.redirectTo) {
					const redirectFromRelative = getRelativePath(link.redirectFrom)
					// redirectTo is a concrete path (e.g., "/locations/123/projects"), extract relative part
					const redirectToParts = link.redirectTo.split('/').filter(Boolean)
					const redirectFromParts = link.redirectFrom.split('/').filter(Boolean)
					
					// Find common prefix length
					let commonLength = 0
					for (let i = 0; i < Math.min(redirectToParts.length, redirectFromParts.length); i++) {
						const fromPart = redirectFromParts[i]
						if (fromPart?.startsWith(':') || fromPart === redirectToParts[i]) {
							commonLength = i + 1
						} else {
							break
						}
					}
					
					// Get relative part from redirectTo
					const redirectToRelative = redirectToParts.slice(commonLength).join('/') || ''
					
					return (
						<Route
							key={`redirect-${index}`}
							path={redirectFromRelative}
							element={<Navigate to={redirectToRelative} state={state} replace />}
						/>
					)
				}
				
				const Component = link.component
				if (!Component) {
					console.warn('RenderSubRoutes: No component provided for route', link)
					return null
				}
				
				const relativePath = getRelativePath(link.linkPattern)
				return (
					<Route key={`route-${index}-${relativePath}`} path={relativePath} element={<Component />} />
				)
			})}
		</Routes>
	)
}

export default RenderSubRoutes
